import Modal from './modal';

export default class ContentModal extends Modal {
    constructor(content, options) {
        super(options);
        this.content = content;
    }

    getContent() {
        return Promise.resolve(this.content);
    }

    setContent(content) {
        this.content = content;
    }
}



// WEBPACK FOOTER //
// ./app/components/modal/js/content-modal.js